export default __webpack_public_path__ + "static/media/sliderImage-5.c03d698a.jpg";